
export const getUsersNotifications = async (data: any, token: string) => {
    const queryString = new URLSearchParams(data).toString(); // Convierte el objeto data a query string

    const urlAlerts = `${process.env.REACT_APP_GLOBAL_ALERTS}get_users_notifications?country=MX&${queryString}`
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_ALERTS_XAPIKEY
        },
    };
    try {
        const res = await fetch(urlAlerts, requestOptions);
        return res.json();
    } catch (error) {
        return error.json();
    }

};

export const createNotifications = async (data: any, token: string) => {
    const urlAlerts = `${process.env.REACT_APP_GLOBAL_ALERTS}create_notifications?country=MX`

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_GLOBAL_ALERTS_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const res = await fetch(urlAlerts, requestOptions);
    return res.json();
};